<template>
  <div>
    <app-cells><h1 class="title">Hotels</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs.vue'

export default {
  name: 'HotelSelectionLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'hotel-map', label: 'Map' },
        { name: 'hotel-selection', label: 'Selection' },
        { name: 'hotels-check-price', label: 'Check price' },
      ],
    }
  }
}
</script>
